var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('embed',{attrs:{"src":"https://app.nanonets.com/#/models","width":"100%","height":"800px"}})])}]

export { render, staticRenderFns }